angular.module('TetherApp').directive('tetherImage', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherImage.html'
    }
});
